import * as _ from "lodash";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Template } from "../models/template.model";
import { TemplateLanguage } from "../../../shared/Models/enums/TemplateLanguage.enum";
import { TemplateType } from "../../../shared/Models/enums/TemplateType.enum";
import { TemplateService } from "../services/template.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DeleteTemplateDialogComponent } from "./delete-template-dialog/delete-template-dialog.component";
import { FilterableTableComponent } from "src/app/shared/table/filterable-table.component";
import { ToastService } from "src/app/shared/toast.service";
import { DeviceCheckService } from "../../survey/shared/services/device-check.service";
import { Table } from "primeng/table";
import { ColumnTypes } from "src/app/shared/Models/enums/ColumnTypeEnum";
import { first } from "rxjs/operators";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";

@Component({
  selector: "app-templates-overview",
  templateUrl: "./templates-overview.component.html",
  styleUrls: ["./templates-overview.component.scss"],
})
export class TemplatesOverviewComponent
  extends FilterableTableComponent<Template>
  implements OnInit
{
  @ViewChild("dt") dataTable: Table;

  canWrite: boolean = false;
  allCols = [
    {
      field: "typeText",
      header: "Document Type",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "version",
      header: "Version Number",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.NUMBER,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "languageText",
      header: "Template Language",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "templateName",
      header: "Document Name",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "networkOwner",
      header: "Network Owner",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "templateDescription",
      header: "Name",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
  ];
  showAllData: boolean;

  constructor(
    private templateService: TemplateService,
    private modalService: NgbModal,
    private permissionService: PermissionsService,
    toastService: ToastService,
    deviceCheckService: DeviceCheckService
  ) {
    super(toastService, deviceCheckService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.checkPermissions();
    this.loadData();
  }

  getTemplates(): Template[] {
    return null;
  }

  getFileInputId(type: TemplateType, language: TemplateLanguage) {
    return `fileInput_${type}_${language}`;
  }

  download(template: Template) {
    this.templateService.download(template);
  }

  delete(template: Template) {
    const modalRef = this.modalService.open(DeleteTemplateDialogComponent);
    modalRef.componentInstance.template = template;

    modalRef.componentInstance.yes
      .pipe(first())
      .subscribe(() => this.loadData());
  }

  upload(template: Template, e: any): void {
    const file = e.target.files[0];
    this.templateService
      .uploadTemplate(template.id, file)
      .then(() => this.loadData());
  }

  onChangeCheckMark(e: any) {
    this.loadData();
  }

  private loadData() {
    if (this.showAllData)
      this.templateService
        .getAllTemplates()
        .pipe(first())
        .subscribe((res) => {
          this.tableValues = res;
          this.globalFilter$.next(this.globalFilter);
        });
    else
      this.templateService
        .getLatestTemplates()
        .pipe(first())
        .subscribe((res) => {
          this.tableValues = res;
          this.globalFilter$.next(this.globalFilter);
        });
  }

  private checkPermissions() {
    this.canWrite = this.permissionService.allowed(
      PermissionsEnum.ManageDocumentTemplates
    );
  }
}
